import { getProfilePassword, initSetProfilePassword } from "../redux/actions";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useEditPassword = () => {
  const { profilePasswordSuccess, profilePasswordError } = useSelector((state) => state.profileReducer);
  const [passwordObj, setPasswordObj] = useState({
    password: "",
    maskedPassword: "",
    isEyeClosed: true,
  });
  const [confirmPasswordObj, setConfirmPasswordObj] = useState({
    password: "",
    maskedPassword: "",
    isEyeClosed: true,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isCloseModalOpened, setCloseMOdalIsOPened] = useState(false);
  const [confirmationError, setConfirmationError] = useState("");
  const [errors, setErrors] = useState({})
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [passwordSuccess, setPasswordSuccess] = useState(false);
  // ✅ Watch for success / error from redux
  useEffect(() => {
    if (profilePasswordSuccess) {
      setPasswordSuccess(true);
      setTimeout(() => {
        setPasswordSuccess(false);
        dispatch(getProfilePassword())
        navigate("/profile/profile-info");
      }, 3000);
    }
    if (profilePasswordError?.new_password?.length) {
      setConfirmationError(profilePasswordError?.new_password[0]);
      setIsErrorVisible(true);
    }
  }, [profilePasswordSuccess, profilePasswordError, navigate]);

  const handlePasswordChange = (e) => {
    const { value } = e.target;
    if (e.target.value.length < passwordObj.password.length) {
      let newPassword = passwordObj.password.slice(0, -1);
      setPasswordObj({
        ...passwordObj,
        password: newPassword,
        maskedPassword: "*".repeat(value.length),
      });
    } else {
      let inpcahracters = "";
      const lastCharacter = value.charAt(value.length - 1);
      inpcahracters = passwordObj.password + lastCharacter;
      setPasswordObj({
        ...passwordObj,
        password: inpcahracters,
        maskedPassword: "*".repeat(value.length),
      });
    }
  };
  const handleConfirmPasswordChange = (e) => {
    const { value } = e.target;
    if (e.target.value.length < confirmPasswordObj.password.length) {
      let newPassword = confirmPasswordObj.password.slice(0, -1);
      setConfirmPasswordObj({
        ...confirmPasswordObj,
        password: newPassword,
        maskedPassword: "*".repeat(value.length),
      });
    } else {
      let inpcahracters = "";
      const lastCharacter = value.charAt(value.length - 1);
      inpcahracters = confirmPasswordObj.password + lastCharacter;
      setConfirmPasswordObj({
        ...confirmPasswordObj,
        password: inpcahracters,
        maskedPassword: "*".repeat(value.length),
      });
    }
  };
  const handlePasswordEye = () => {
    setPasswordObj({
      ...passwordObj,
      isEyeClosed: !passwordObj.isEyeClosed,
    });
  };
  const handleConfirPasswordEye = () => {
    setConfirmPasswordObj({
      ...confirmPasswordObj,
      isEyeClosed: !confirmPasswordObj.isEyeClosed,
    });
  };
  const openCloseModal = () => {
    setCloseMOdalIsOPened(true);
  };

  const closeCloseModal = () => {
    setCloseMOdalIsOPened(false);
  };
  useEffect(() => {
    if (passwordObj.password === confirmPasswordObj.password) {
      setIsErrorVisible(false);
      setConfirmationError("");
    }
  }, [passwordObj, confirmPasswordObj]);

  const checkPassword = () => {
    const errorsObj = {};
    const { password } = passwordObj;
    const { password: confirmPassword } = confirmPasswordObj;

    // Check for empty fields
    if (!password) errorsObj.password = 'Please enter password.';
    if (!confirmPassword) errorsObj.confirm_password = 'Please enter confirm new password.';

    // Check for max length
    // if (password && password.length < 12) {
    //   errorsObj.password = 'Ensure this field has at least 12 characters.';
    // }
    if (password && password.length < 8) {
      errorsObj.password = 'Password must be at least 8 characters long.';
    }
    const hasErrors = Object.keys(errorsObj).length > 0;

    if (hasErrors) {
      setErrors(errorsObj);
      setConfirmationError("");
      return;
    }

    // Check for mismatch
    if (password !== confirmPassword) {
      setErrors({});
      setIsErrorVisible(true);
      setConfirmationError("password mismatch.");
      return;
    }
    // All validations passed
    dispatch(
      initSetProfilePassword({
        new_password: confirmPassword,
      })
    );
    setErrors({});
    setIsErrorVisible(false);
    setConfirmationError("");
    // navigate("/profile/profile-info");
  };

  const loseChanges = () => {
    setPasswordObj({
      password: "",
      maskedPassword: "",
      isEyeClosed: true,
    });
    setConfirmPasswordObj({
      password: "",
      maskedPassword: "",
      isEyeClosed: true,
    });
    navigate("/profile/profile-info");
    setCloseMOdalIsOPened(false);
  };
  return {
    passwordObj,
    confirmPasswordObj,
    isCloseModalOpened,
    errors,
    handleConfirmPasswordChange,
    handlePasswordChange,
    handlePasswordEye,
    handleConfirPasswordEye,
    openCloseModal,
    closeCloseModal,
    checkPassword,
    isErrorVisible,
    passwordSuccess,
    confirmationError,
    loseChanges,
  };
};

export default useEditPassword;
